'use strict';
const _ = require('lodash');

const biStore = require('./stores/biStore');
const events = require('./events');
const errors = require('./errors');
const intent = 'WIX_CODE_SITE_API';
const REPORT_BI_MESSAGE_TYPE = 'reportBI';
const REPORT_TRACE_MESSAGE_TYPE = 'reportTrace';

const ACTION_NAMES = {
  WORKER_CREATED: 'WORKER_CREATED',
  SCRIPT_LOADED: 'SCRIPT_LOADED',
  INIT_APP_FOR_PAGE: 'INIT_APP_FOR_PAGE',
  CREATE_CONTROLLERS: 'CREATE_CONTROLLERS',
  CONTROLLER_PAGE_READY: 'CONTROLLER_PAGE_READY',
  APP_LOADED: 'APP_LOADED',
  BOOTSTRAP_DONE: 'BOOTSTRAP_DONE',
  USER_CODE_LOADED: 'USER_CODE_LOADED',
  USER_GENERATED_APPS_LOADED: 'USER_GENERATED_APPS_LOADED',
  ALL_APPS_PAGE_READY: 'ALL_APPS_PAGE_READY',
  APP_PAGE_READY: 'APP_PAGE_READY',
  HANDLE_INIT_FAILED: 'HANDLE_INIT_FAILED',
  PAGE_READY_FAILED: 'PAGE_READY_FAILED'
};

const BI_PARAM_KEY_MAP = {
  timeSpent: 'actionDurationMs',
  workerId: 'pageId',
  metaSiteId: 'msid',
  viewerSessionId: 'vsi'
};

const TRACE_PARAM_KEY_MAP = _.assign({}, BI_PARAM_KEY_MAP, {
  appId: 'appName',
  ts: 'timeFromStartMs'
});

function postMessageToSanta(sendMsgFunc, {type, reportDef, params}) {
  sendMsgFunc({
    intent,
    reportDef,
    type,
    params
  });
}

function report(sendMsgFunc, reportDef, params) {
  postMessageToSanta(sendMsgFunc, {type: REPORT_BI_MESSAGE_TYPE, reportDef, params});
}

function trace(sendMsgFunc, biParams) {
  const defaultParams = {appId: 'santa', tracePosition: 'after'};
  const params = _(biStore.getBiSession())
    .pick(['pageId', 'ts', 'metaSiteId', 'pageUrl'])
    .assign(defaultParams, biParams, {timestampMs: new Date().getTime()})
    .mapKeys((param, key) => TRACE_PARAM_KEY_MAP[_.camelCase(key)] || key)
    .value();

  postMessageToSanta(sendMsgFunc, {type: REPORT_TRACE_MESSAGE_TYPE, reportDef: events.REPORT_TRACE, params});
}

function reportPerformanceBI(sendMsgFunc, reportDef, biParams) {
  const params = _(biStore.getBiSession())
    .pick(['pageId', 'metaSiteId', 'pageUrl', 'postSSR', 'requestId', 'viewerSessionId'])
    .assign(biParams)
    .mapKeys((param, key) => BI_PARAM_KEY_MAP[key] || key)
    .value();

  postMessageToSanta(sendMsgFunc, {type: REPORT_BI_MESSAGE_TYPE, reportDef, params});
}

function reportPlatformRenderStep(sendMsgFunc, biParams) {
  reportPerformanceBI(sendMsgFunc, events.PLATFORM_RENDER_STEP, biParams);
}

function reportPlatformRenderError(sendMsgFunc, biParams) {
  reportPerformanceBI(sendMsgFunc, errors.PLATFORM_RENDER_ERROR, biParams);
}

function getBiServices(sendMsgFunc) {
  return {
    reporters: {
      reportBI: report.bind(null, sendMsgFunc)
    }
  };
}

module.exports = {
  report,
  trace,
  reportPlatformRenderStep,
  reportPlatformRenderError,
  getBiServices,
  ACTION_NAMES
};
